export const RELOAD_PLUGIN_DRAWER_BUTTON_ROLE = 'reload-plugin-drawer-button';
